import React from 'react';

import { ArrangementStatusContainer } from '../StatusComponentMap.css';

import statusMapIcon_gas_blue from 'static/images/icon/statusMapIcon_gas_blue.png';

import status_legend_icon_blue from 'static/images/icon/status_legend_icon_blue.png';
import status_legend_icon_warning from 'static/images/icon/status_legend_icon_warning.png';
import status_legend_icon_danger from 'static/images/icon/status_legend_icon_danger.png';
import status_legend_icon_none from 'static/images/icon/status_legend_icon_none.png';
import status_legend_icon_pH from 'static/images/icon/status_legend_icon_pH.png';

const StatusLegend = () => {
  return (
    <ArrangementStatusContainer>
      <table>
        <thead>
          <tr>
            <th>아이콘</th>
            <th>명칭</th>
            <th>아이콘</th>
            <th>상태</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <img src={statusMapIcon_gas_blue} />
            </td>
            <td>
              O<sub>2</sub>
            </td>
            <td>
              <img src={status_legend_icon_blue} />
            </td>
            <td>정상</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>
              <img src={status_legend_icon_warning} />
            </td>
            <td>경고</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>
              <img src={status_legend_icon_danger} />
            </td>
            <td>위험</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>
              <img src={status_legend_icon_none} />
            </td>
            <td>미수신</td>
          </tr>
        </tbody>
      </table>
    </ArrangementStatusContainer>
  );
};

export default StatusLegend;
